export default function isSupport(property) {
  return property.substr(0, 9) === '@supports';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela-utils/es/isSupport.js
// module id = 1118
// module chunks = 0